// Actions
export const SET_TAGS = 'setTags';

// Mutations
export const STORE_SET_TAGS = 'storeSetTags';

const state = {
    tags: []
};

const getters = {
    tags(state) {
        return state.tags
    }
};

const actions = {
    [SET_TAGS](context, tags) {
        context.commit(STORE_SET_TAGS, tags);
    }
};

const mutations = {
    [STORE_SET_TAGS](state, tags) {
        state.tags = tags;
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}